export const iOSAppStoreLink = 'https://apps.apple.com/app/startpage-privacy-browser/id6478921430'

// TODO: Update this link when we have a legit link
export const androidAppStoreLink = 'https://play.google.com/store/apps/details?id=com.startpage.app'
